import * as Vuex from 'vuex';
import { ApiModel } from '@/models/Product';
import Api from '@/Api';
import { Position, WidgetType } from '@/models/Enums';
import { LiteShopModel, ShopInfoModel } from '@/models/ShopDetails';
import { ILoadProducts } from '@/models/Parameters';
import AmazonProductDetailsModel from '@/models/ProductDetails';

interface SharedProductStore {
  idealo: ProductStore;
  amazon: ProductStore;
  localShop: ProductStore;
  dkShop: ProductStore;
  localShopLite: LiteProductStore;
  location: ProductStore;
  [key: string]: ProductStore;
}
interface ProductStore {
  products: ApiModel[];
  location?: any;
  activeIndex: number;
}
interface LiteProductStore extends ProductStore{
  liteProducts: ShopInfoModel[];
}

export default function articleStore() {
  return new Vuex.Store<SharedProductStore>({
    state: {
      location: {
        products: [],
        location: null,
        activeIndex: 0
      },
      idealo: {
        products: [],
        activeIndex: 0,
      },
      amazon: {
        products: [],
        activeIndex: 0,
      },
      localShop: {
        products: [],
        activeIndex: 0,
      },
      dkShop: {
        products: [],
        activeIndex: 0,
      },
      localShopLite:{
        products: [],
        activeIndex: 0,
        liteProducts: []
      },
    },
    mutations: {
      setStateLocation(state, location: string|null) {
        state.location.location = location;
      },
      setProducts(state, prods: ApiModel[]) {
        const isAdmin: boolean = (window as any).dkVars.isAdmin;
        const myProds = isAdmin ? prods : prods.filter(val => val.details != null && !((val.details as AmazonProductDetailsModel).message));
        if (myProds.length > 0) {
          state[myProds[0].type].products = myProds;
          state.location.location = myProds[0].location;
        }
      },
      setLiteShops(state, shopModel: LiteShopModel) {
        if (shopModel.shops.length > 0) {
          state.localShopLite.liteProducts = shopModel.shops;
          state.location.location = shopModel.location;
        }
      },
      setActiveProduct(state, data: any) {
        // console.info(state[data.type].activeIndex, data.id, data.currentIndex, data.newIndex);
        if (state[data.type].activeIndex === data.newIndex) {
          return;
        }
        if (data.position === Position.Side && state[data.type].products[data.newIndex].order > 2) {
          const oldOrder = state[data.type].products[data.currentIndex].order;
          const newOrder = state[data.type].products[data.newIndex].order;
          // console.log(oldOrder, newOrder);
          state[data.type].products[data.currentIndex].order = newOrder;
          state[data.type].products[data.newIndex].order = oldOrder;
        }
        state[data.type].activeIndex = data.newIndex;
      },
    },
    actions: {
      async loadProducts(ctx, data: ILoadProducts) {
        try {
          if (data.id === '') {
            const response = await Api.getLiteShops(data.extra);
            ctx.commit('setLiteShops', await response.json())
          } else {
            let response = await Api.getProducts(data);
            const products = response.status === 204 ? [] : await response.json() as ApiModel[];
            if ((products == null || products.length === 0)
              && data.type === WidgetType.LocalShop
              && response.status === 204) {
              response = await Api.getLiteShops(data.extra);
              ctx.commit('setLiteShops', await response.json())
            } else {
              // console.table(products.map(p=> `${p.id}, ${p.pk}`));
              ctx.commit('setProducts', products)
            }
          }

        } catch (e) {
          // tslint:disable-next-line:no-console
          console.error(e);
        }
      },
    },
    getters: {
      products: (state) => (type:string) => state[type].products,
      activeIndex: (state) => (type:string) => {
        return state[type].activeIndex;
      },
      activeProduct: (state, getters) => (type:string) => {
        return state[type].products[getters.activeIndex(type)]
      },
      liteProducts: (state) => {
        return state.localShopLite.liteProducts;
      },
      productDetails: (state, getters) => (type:string) =>  {
        return getters.activeProduct(type) == null ? null : getters.activeProduct(type).details
      },
    }
  });
}